'use strict';

require('@firebase/messaging');

//# sourceMappingURL=index.cjs.js.map



//////////////////
// WEBPACK FOOTER
// ./~/firebase/messaging/dist/index.cjs.js
// module id = 745
// module chunks = 0